import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy">
      <p>
        La presente informativa descrive in modo indicativo le modalità con cui
        Vinko raccoglie e tratta i dati personali degli utenti che utilizzano il
        sito e i canali collegati. Il testo definitivo dovrà essere verificato
        e integrato da un professionista.
      </p>
      <h3>Titolare del trattamento</h3>
      <p>Il titolare del trattamento è Vinko. Per contatti scrivere a fede.scalici.98@gmail.com.</p>
      <h3>Dati raccolti</h3>
      <p>Nome, cognome, email, telefono e altre informazioni fornite volontariamente tramite i moduli del sito.</p>
      <h3>Finalità</h3>
      <p>Gestione delle richieste di contatto, delle candidature per collaborazioni e delle attività di assistenza.</p>
      <h3>Diritti dell'interessato</h3>
      <p>Puoi richiedere in qualsiasi momento accesso, rettifica o cancellazione dei tuoi dati scrivendo a fede.scalici.98@gmail.com.</p>
    </LegalLayout>
  );
}
